export const antdOverrides = {
  token: {
    colorTextBase: '#1a1a2e',
    colorText: '#374151',
    colorTextLabel: '#374151',
    colorPrimaryText: '#584CF4',
    colorPrimary: '#584CF4',
    colorError: '#EF4444',
    colorErrorText: '#EF4444',
    borderRadius: 10,
    fontSize: 14,
    fontWeightStrong: 600,
    colorLink: '#584CF4',
    colorLinkActive: '#4338ca',
    fontSizeHeading1: 24,
    fontSizeHeading2: 18,
    fontSizeLG: 14,
    controlHeight: 32,
    fontSizeIcon: 10,
    controlInteractiveSize: 14,
    colorBgLayout: '#F5F6FA',
  },
};
